import { Link } from "react-router-dom";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import './NB.css'

export default function NB(){
    return <b>
        <Navbar className='navbg' variant="dark">
            <Container>
                <Link className='hm' to={'/'}>
                    {window.screen.width < 580 ?
                        <img
                            src="../photos/Logo/logo4.png"
                            width="80"
                            height="60"
                            className="d-inline-block align-top"
                            alt="হোম"
                        /> :
                        <img
                            src="../photos/Logo/logo7.png"
                            width="200"
                            height="45"
                            className="d-inline-block align-top"
                            alt="হোম"
                        />
                    }
                </Link>
                <Nav className="navbar-right">
                    <Link to={'/'}>
                        <img
                            src="../photos/NavIcons/home.png"
                            width="30"
                            height="30"
                            className="d-inline-block align-top"
                            alt="হোম"
                        />হোম
                    </Link>

                    <Link to={"/search"}>
                        <img
                            src="../photos/NavIcons/search.png"
                            width="30"
                            height="30"
                            className="d-inline-block align-top"
                            alt="সার্চ"
                        />সার্চ
                    </Link>

                    <Link to={"/books"}>
                        <img
                            src="../photos/NavIcons/books.png"
                            width="30"
                            height="30"
                            className="d-inline-block align-top"
                            alt="বই"
                        />হাদীস বই
                    </Link>


                    <Link to={"/topics"}>
                        <img
                            src="../photos/NavIcons/topics.png"
                            width="30"
                            height="30"
                            className="d-inline-block align-top"
                            alt="বিষয়ভিত্তিক হাদীস"
                        />বিষয়ভিত্তিক হাদীস
                    </Link>
                </Nav>
            </Container>
        </Navbar>
        <br></br>
    </b>
}